import React from 'react';
import LoginForm from '../LoginForm/LoginForm';
import HeaderGeometry from '../../images/header_geometry_borderless.png'
import SemiCircle from '../../images/semicircle_lighblue.png'
import { withTranslation } from 'react-i18next';
import './StartScreen.less'

class StartScreen extends React.Component {
    static defaultProps = {
        initialMode: 'login',
        initialShow: true,
        logoWidth: '300px',
        logoSubTitle: null,
        buttonHeader: null,
        buttonText: 'Start the Experience',        
        onDiscard: function(){},
    };

    hasStarted = false;

    constructor(props) {
        super(props);

        this.state = {
            show: props.initialShow,
            mode: props.initialMode,
            username: '',
            password: '',
        };

        this.loggedIn = false;

        if (props.register) {
            props.register(this);
        }
    }

    show = () => {
        this.setState({show: true, mode: this.props.initialMode})
    }

    hide = () => {
        this.setState({show: false})
    }

    start = (username) => {
        this.setState({ show: false });

        if (typeof this.props.onUsernameEntered === 'function') {
            this.props.onUsernameEntered(username);
        }

        if (!this.hasStarted) {
            if (typeof this.props.onStart === 'function') {
                this.props.onStart();
                this.hasStarted = true;
            }
        }
    };

    discard = () => {
        this.setState({ show: false });
        this.props.onDiscard();
    };

    render() {
        if (this.state.show) {
            return (
                <div style={this.props.style} className="start-screen" ref={this.userloginRef}>
                    <div className='header_image' src={HeaderGeometry}/>
                    <div className="container" id='welcome'>
                        <div className="container__body">
                        <h1>{this.props.t('Welcome1')}</h1>
                        <label className='container_text'>
                            {this.props.t('Welcome2')}
                            {this.props.t('Welcome3')}
                            <br/>
                            {this.props.t('Welcome4')}
                            </label>
                        </div>
                        <div className="container__body__background"/>
                        <div className="container__body">
                            <img alt="" src={SemiCircle} className='container__decor'/>
                            {this.state.mode === 'login' && (
                                <LoginForm
                                    onStart={this.start}
                                    onDiscard={this.discard}                                    
                                    buttonText={this.props.buttonText}
                                    onLogin={this.props.onLogin}
                                />
                            )}
                        </div>
                    </div>
                    <button title="close" className="close" style={{display: this.hasStarted ? "block" : "none", fontWeight: "normal", fontSize: "medium", marginTop: "15px"}} onClick={this.hide}>                        
                    </button>
                </div>
            );
        }

        return null;
    }
}

export default withTranslation()(StartScreen);
